import WEEKDAY from 'constants/time/weekday.const';

const WEEKDAY_TAG = Object.freeze({
  [WEEKDAY.sun]: 'Su',
  [WEEKDAY.mon]: 'Mo',
  [WEEKDAY.tue]: 'Tu',
  [WEEKDAY.wed]: 'We',
  [WEEKDAY.thu]: 'Th',
  [WEEKDAY.fri]: 'Fr',
  [WEEKDAY.sat]: 'Sa',
});

export default WEEKDAY_TAG;
